export const projectIRI = uuid => `/api/projects/${uuid}`;
export const fbacIRI = uuid => `/api/facebook_ads_accounts/${uuid}`;
